import style from "./style.less";
import React, { useEffect, useRef, useState } from "react";
import { Flex, FloatingBall } from "react-vant";
import { LocalConfig, NumericalConfig } from "@/config";
import MyNavLink from "../MyNavLink";

const HomeInviteWheelFloatBall = (props) => {
  //悬浮效果
  const InviteWheelImg = () => {
    const [count, setCount] = useState(0);
    const timer = useRef(null);
    useEffect(() => {
      if (timer.current != null) {
        clearTimeout(timer.current);
        timer.current = null;
      }
      timer.current = setTimeout(() => {
        if (count == 9) {
          setCount(0);
          return;
        }
        setCount(() => count + 1);
      }, 200);
      return () => {
        clearTimeout(timer.current);
      };
    }, [count]);
    return React.useMemo(
      () => (
        <div class={style.float_ball}>
          <div class={style.float_des}>
            <div class={style.float_img}>
              <img
                src={require("@/assets/images/lucky_wheel/zhuanpan.png").default}
                style={{ display: "inherit", width: "100%" }}
              />
            </div>
            <div class={style.float_text} style={{ display: "inherit", width: "90%" }}>
              {(NumericalConfig.inviteWheel.targetAmount / 100).toFixed(0)} {LocalConfig.currencyCode}
            </div>
          </div>
        </div>
      ),
      [count]
    );
  };

  console.log(props.floatBall);
  return (
    <div class={style.float_ball_container} style={{ display: props.floatBall ? "block" : "none" }}>
      <FloatingBall
        offset={{
          bottom: "7.5rem",
        }}
        adsorb={true}
      >
        <Flex align="center" justify="center">
          <MyNavLink to="/inviteWheel">
            <InviteWheelImg />
          </MyNavLink>
        </Flex>
      </FloatingBall>
    </div>
  );
};

export default HomeInviteWheelFloatBall;
